<template>
    <div class="">
        <b-toast></b-toast>
        <div class="">
            <b-card class="grid-view-item overflow-hidden">
                <div id="container-map" v-if="status_mapa">
                    <l-map :center="center" :zoom="zoom" :options="{attributionControl: false, zoomControl: false, fullscreenControl: true}" ref="mymap" style="height: 100%; overflow: hidden;">
                        <l-control-attribution position="bottomright" prefix="Spore Cloud"></l-control-attribution>
                        <l-control-layers :collapsed="true" :position="layersPosition" :sort-layers="true"/>
                        <l-tile-layer :key="tileProvider.name" :name="tileProvider.name" :url="tileProvider.url" :visible="tileProvider.visible" layer-type="base" v-for="tileProvider in tileProviders"/>
                        <l-control-zoom position="topleft" :options="{ zoomInTitle: $t('Labels.ZoomIn'), zoomOutTitle: $t('Labels.ZoomOut') }"/>
                        <l-control position="topright" v-if="showButtons === true">
                          <b-button @click="showFilters = !showFilters" v-if="!showFilters" class="btn-icon btn-map rounded-circle" variant="primary" :title="$t('Labels.Filter')" v-b-tooltip.right="{ variant: 'primary' }" >
                            <iconBase :width="18" :height="18" iconColor="#FFFF" ><iconFilter/></iconBase>
                          </b-button>
                        </l-control>
                        <l-control position="topright">
                          <b-card v-if="showFilters">
                            <b-row align-h="end">
                              <b-col>
                                <b-button
                                  variant="flat-primary"
                                  class="btn-icon float-right btn-map rounded-circle"
                                  @click="showFilters = false"
                                >
                                  <feather-icon icon="XIcon" />
                                </b-button>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col cols="12">
                                <b-form-group
                                  :label="$tc('Labels.ServiceButton')"
                                  label-for="filter"
                                >
                                  <b-form-checkbox
                                    checked="true"
                                    class="custom-control-primary"
                                    name="check-button"
                                    v-model="checkAll"
                                  >
                                    {{$t('Labels.All')}}
                                  </b-form-checkbox>
                                  <b-form-select name="filter" v-model="filter" :options="trackerOptions" multiple :select-size="10" />
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col cols="12">
                                <b-button
                                  variant="primary"
                                  @click="getMapa()"
                                  class="mt-1 float-right"
                                >
                                  {{$t("Labels.Filter")}}
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-card>
                        </l-control>
                        <l-control position="verticalcenterright" class="leaflet-topcenter">
                          <div v-if="this.onAlert" class="container-tags my-1">
                            <h5>{{$t('Labels.ServiceButtonOnAlert')}}</h5>
                            <badgeTracker v-for="item in alertTrackers" :key="item.id"
                              :label="item.name"
                              :status="item.state"
                              @click="goToMarker(item.position)"
                            />
                            <audio controls id="mySound" autoplay loop  hidden>
                              <source :src="require('@/assets/sounds/alarm/sound-alarm.mp3')" type="audio/wav">
                              Your browser does not support the audio element.
                            </audio>
                          </div>
                        </l-control>
                        <v-marker-cluster class="micluster">
                            <l-marker :draggable="item.draggable" :key="item.id" :lat-lng.sync="item.position" :visible="item.visible" v-for="item in markers">
                                <l-icon :icon-size="[40,40]">
                                  <avatarMarker
                                    :label="item.name.substr(0,2)"
                                    :status="item.state"
                                  />
                                </l-icon>
                                <l-popup>
                                    <div class="popup">
                                      <valueItem
                                        :value="item.name"
                                        :description="$t('Labels.Alias')"
                                        img="panicbutton"
                                      />
                                      <valueItem
                                        :value="item.site"
                                        :description="$t('Labels.Site')"
                                        img="georeference"
                                      />
                                      <valueItem
                                        :value="item.contact_name"
                                        :description="$t('Labels.ContactName')"
                                        img="contact"
                                      />
                                      <valueItem
                                        :value="item.contact_number"
                                        :description="$t('Labels.ContactNumber')"
                                        img="phone"
                                      />
                                      <valueItem
                                        :value="item.address"
                                        :description="$t('Labels.Address')"
                                        img="pointtracker"
                                      />
                                      <hr>
                                      <alertPanicButton v-if="userType === 'TS'" tipo="conexion" :status="'c' + item.conection" />
                                      <alertPanicButton tipo="energia" :status="'e' + item.energy" />
                                      <alertPanicButton tipo="estado" :status="item.state" />
                                      <valueItem
                                        :value="formDate(item.updated_at, 'dayJs')"
                                        :description="$t('Labels.LastUpdated')"
                                        img="fecha"
                                      />
                                      <div class="text-center">
                                        <b-button @click="deviceInformation(item.id)" variant="primary" size="sm">
                                          {{$t('Labels.SeeMore')}}
                                        </b-button>
                                      </div>

                                </div>
                                </l-popup>
                            </l-marker>
                        </v-marker-cluster>
                    </l-map>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LControlAttribution,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControlLayers,
  LControl,
  LControlZoom
} from 'vue2-leaflet'

import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import valueItem from '@core/spore-components/valueItem/valueItem.vue'
import alertPanicButton from '@core/spore-components/alertPanicButton/alertPanicButton.vue'
import request from '@/libs/request/index'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import { batteryCalculate, empty, timeZoneDate } from '@/libs/tools/helpers'
import iconBase from '@core/spore-components/icons/iconBase'
import iconFilter from '@core/spore-components/icons/iconFilter'
import {
  BToast,
  BButton,
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BFormGroup,
  BFormCheckbox
} from 'bootstrap-vue'
import avatarMarker from '@core/spore-components/avatarMarkerButton/avatarMarkerButton.vue'
import badgeTracker from '@core/spore-components/badgeTracker/badgeTracker.vue'

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

const DATA = {
  code: 200,
  data: [],
  msg: 'Ok'
}

export default {
  name: 'mapa',
  components: {
    LMap,
    LControlAttribution,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControlLayers,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    valueItem,
    alertPanicButton,
    BToast,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormSelect,
    BFormGroup,
    BFormCheckbox,
    iconBase,
    iconFilter,
    avatarMarker,
    LControl,
    LControlZoom,
    badgeTracker
  },
  data () {
    return {
      userType: '',
      onAlert: false,
      response: [],
      tileProviders,
      layersPosition: 'topright',
      center: [20.662396323989693, -103.37640969334421],
      staticAnchor: [12, 27],
      markers: [],
      status_mapa: false,
      DATA,
      batteryCalculate,
      fitBounds: true,
      alertTrackers: [],
      zoom: 10,
      trackerOptions: [],
      filter: [],
      fullscreen: false,
      checkAll: true,
      showFilters: false,
      showButtons: false,
      totalRows: 0,
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'state',
        byOrder: 'DESC',
        imei: '',
        name: ''
      }
    }
  },
  methods: {
    makeToast (append = false, name) {
      this.$bvToast.toast(this.$t('Labels.ServiceButton') + ': ' + name, {
        title: this.$t('Labels.ActiveAlerts'),
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger'
      })
    },
    formDate (date, type) {
      return timeZoneDate(date, type)
    },
    async getMapa () {
      const params = {
        url: 'panic_button/mapa/list',
        method: 'GET',
        params: {
          filter: this.filter.join(',')
        }
      }
      await request(params).then(data => {
        data = data.data.data
        const positions = []
        this.markers = []
        this.onAlert = false
        this.alertTrackers = []
        for (let i = 0; i < data.length; i++) {
          if (!empty(data[i].latlong)) {
            const lat = data[i].latlong.split(',')[0]
            const lng = data[i].latlong.split(',')[1]
            positions.push([lat, lng])
            this.markers.push({
              position: { lat: lat, lng: lng },
              name: data[i].name,
              energy: data[i].energy,
              conection: data[i].conection,
              state: data[i].state,
              updated_at: data[i].updated_at,
              deveui: data[i].deveui,
              address: data[i].address,
              id: data[i].uuid,
              draggable: false,
              visible: true
            })
            if (data[i].state === '1') {
              this.onAlert = true
              this.makeToast(true, data[i].name)
              this.alertTrackers.push({
                id: data[i].uuid,
                name: data[i].name,
                energy: data[i].energy,
                conection: data[i].conection,
                status: data[i].state,
                position: [lat, lng]
              })
            }
          }
        }
        this.status_mapa = true
        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          maps.fitBounds(positions)
          app.showButtons = true
        }, 1000)
      }).catch(() => {
        this.markers = []
      })
    },

    async getOptionsTrackers () {
      const params = {
        url: 'panic_button',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(data => {
        this.trackerOptions = []
        for (let p = 0; p < data.data.data.rows.length; p++) {
          this.trackerOptions.push({ value: data.data.data.rows[p].uuid, text: data.data.data.rows[p].name })
        }
        this.totalRows = data.data.data.count
      })
    },

    deviceInformation (uuid) {
      this.$router.push(`/panic_button/sm/detail/${uuid}`)
    },

    setFitBounds () {
      const positions = []
      this.markers.forEach(item => {
        positions.push([item.position.lat, item.position.lng])
      })
      const maps = this.$refs.mymap.mapObject
      if (maps !== null) {
        maps.fitBounds(positions)
      }
    },
    notifications (name) {
      const greeting = new Notification(this.$t('Labels.ActiveAlerts'), {
        body: this.$t('Labels.ServiceButton') + ': ' + name,
        vibrate: true,
        icon: ' data:image/png;base64,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'
      })

      console.log(greeting)
    },
    goToMarker (position) {
      this.fitBounds = false
      const map = this.$refs.mymap.mapObject
      map.setView(position, 18)
    }
  },
  sockets: {
    panic_button (payload) {
      if (!empty(payload.latlong)) {
        this.markers = this.markers.filter(marker => marker.id !== payload.uuid)
        if (payload.state === '1') this.notifications(payload.name)
        this.markers.push({
          position: { lat: payload.latlong.split(',')[0], lng: payload.latlong.split(',')[1] },
          name: payload.name,
          energy: payload.energy,
          conection: payload.conection,
          state: payload.state,
          updated_at: payload.updated_at,
          deveui: payload.deveui,
          address: payload.address,
          id: payload.uuid,
          draggable: false,
          visible: true
        })
        if (this.fitBounds) {
          this.setFitBounds()
        }

        if (payload.state === '1') {
          this.alertTrackers = this.alertTrackers.filter(marker => marker.id !== payload.uuid)
          this.onAlert = true
          this.makeToast(true, payload.name)
          this.alertTrackers.push({
            id: payload.uuid,
            name: payload.name,
            energy: payload.energy,
            conection: payload.conection,
            state: payload.state,
            position: [payload.latlong.split(',')[0], payload.latlong.split(',')[1]]
          })
        } else {
          this.alertTrackers = this.alertTrackers.filter(marker => marker.id !== payload.uuid)
          this.onAlert = false
        }
      }
    }
  },
  created () {
    if (!('Notification' in window)) {
      console.log('This browser does not support desktop notification')
    } else if (Notification.permission !== 'granted') {
      Notification.requestPermission()
    }
    this.getMapa()
    this.getOptionsTrackers()
    this.userType = this.$store.state.session.AppActiveUser().userRole
  },
  watch: {
    checkAll (val) {
      if (val) {
        this.filter = []
      }
    },
    filter (val) {
      if (val.length > 0) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  @import "@/assets/scss/pages/Map.scss";
</style>
